import React from "react";

const Settings: React.FC = () => {
  return <>SETTINGS PAGE</>;
};

export default Settings;
